<template>
  <section class="content">
    <div class="bg" />
    <header>
      <h1>Unsplash by Camera</h1>
      <p class="subTitle">
        Photos organized by camera brands, models and technical dimensions
      </p>
    </header>
    <CameraViz />
    <aside>
      <h2>About this visualization</h2>
      <p>Almost all photos uploaded to Unsplash contain "exif" data, that is saved by the camera and contains all technical details of the shot.</p>
      <p>The visualization looks into different aspects: camera brand and model, focal length, ISO, exposure time and aperture.</p>
      <p>Use the zoom and the brush tools to spread out data points that are too close together.</p>
      <p>Clicking on each dot shows you the quantity of photos using the selected metric. Click on this number see the photo gallery of the first 100 photos. Can you see similarities?</p>
      <!-- <p>Not yet implemented: Clicking on the camera model will give you even more details about the different model of each brand.</p> -->
    </aside>
  </section>
</template>

<script>
// @ is an alias to /src
import CameraViz from "@/components/cameraviz.vue"

export default {
    name: "CameraPage",
    components: {
        CameraViz
    }
}
</script>

<style lang="stylus">
.content {
}
</style>


